//@ts-check

/**
 *  @description Check if the data is contractor or not
 *
 * @param {string} psid "
 * @returns {"0" | "1"}
 */
const isContractor = (psid) => {
    // Check if psid is present or not
    if (psid) {
      // For contractors
      if (psid.startsWith("5")) {
        return "1";
      }
      // For Alaska Employees
      else if (psid.startsWith("1")) {
        return "0";
      }
      // If nothing matches the user should be a contractor
      else {
        return "0";
      }
    }
  
    return "0";
  };
  
  export default isContractor;
  